var map = {
	"./avatar-1.jpg": "./src/assets/images/user/avatar-1.jpg",
	"./avatar-2.jpg": "./src/assets/images/user/avatar-2.jpg",
	"./avatar-3.jpg": "./src/assets/images/user/avatar-3.jpg",
	"./avatar-4.jpg": "./src/assets/images/user/avatar-4.jpg",
	"./avatar-5.jpg": "./src/assets/images/user/avatar-5.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/user sync recursive ^\\.\\/.*$";